/**
 * @flow
 */

import React, { Component } from 'react'
import { scrollToDesktopSBForm } from '../../../../utils/navigationUtils'
import ButtonTextWithIcon from '../../ButtonTextWithIcon'
import {
  BookNowButtonContainer,
  BookNowButton,
  ButtonSupportText
} from './styledComponents.js'

class TestimonialFooter extends Component {
  render() {
    return (
      <BookNowButtonContainer id="testimonials-desktop-book-now-button">
        <BookNowButton onClick={scrollToDesktopSBForm}>
          <ButtonTextWithIcon text="BOOK NOW" />
        </BookNowButton>
        <ButtonSupportText>Pay when you visit the arcade.</ButtonSupportText>
      </BookNowButtonContainer>
    )
  }
}

export default TestimonialFooter



// WEBPACK FOOTER //
// ./src/components/IbcArcade/TestimonialSection/TestimonialFooter/index.js